import { PartState } from '../types';

/**
 * Curious state - Bizy with eyebrow antennas, communicator badge, and 4 wings
 * Scaled from reference SVG (622x547) to viewBox (316x278)
 * Scale factor: 0.508, centered transform
 */
export const curiousState: PartState = {
	// Filled eyebrow-style antennas (new design)
	antenna1: {
		path: 'M159.03 36.02C161.79 36.02 164.03 38.26 164.03 41.02C164.03 43.78 161.79 46.02 159.03 46.02C157.4 46.02 155.95 45.24 155.04 44.03C148.89 45.30 143.98 48.79 139.98 53.03C135.26 58.30 132.39 64.60 131.23 68.71C130.85 70.04 129.47 70.81 128.14 70.43C126.81 70.05 126.04 68.67 126.42 67.34C127.76 62.61 130.95 55.60 136.26 49.67C140.66 44.75 146.62 40.48 154.24 39.02C155.01 37.24 156.78 36.02 159.03 36.02Z',
		filled: true,
	},
	antenna2: {
		path: 'M203.05 36.02C205.82 36.02 208.06 38.26 208.06 41.02C208.06 43.78 205.82 46.02 203.05 46.02C201.31 46.02 199.78 45.15 198.88 43.81C192.11 44.83 186.76 48.50 182.69 53.03C177.96 58.30 175.09 64.60 173.93 68.71C173.55 70.04 172.17 70.81 170.84 70.43C169.51 70.05 168.74 68.67 169.12 67.34C170.46 62.61 173.65 55.60 178.96 49.67C183.68 44.27 190.18 39.47 199.58 38.34C200.40 36.70 202.10 36.02 203.05 36.02Z',
		filled: true,
	},
	// Body - golden bee body
	body: { x: 103, y: 62, width: 100, height: 162, rx: 32 },
	// Body highlight (rect style for new design)
	bodyHighlight: { x: 103, y: 62, width: 87, height: 162, rx: 32 },
	// Stripes
	stripes: { y1: 140, y2: 169, y3: 198, height: 15 },
	// Eyes - taller rectangular eyes (new design)
	eyes: { y: 95, leftX: 114, rightX: 153, width: 11, height: 18, rx: 5.5 },
	// Right wings (spread wide open)
	wing1Path:
		'M225.08 130.33C200.19 155.59 143.11 152.03 120.24 150.50C118.78 150.33 118.00 148.54 118.84 147.30C146.64 110.11 205.67 82.14 235.58 70.21C266.32 57.99 248.53 112.71 225.08 130.33Z',
	wing2Path:
		'M230.04 155.89C202.81 175.55 146.04 150.98 125.45 141.19C124.13 140.53 124.00 138.59 125.21 137.70C162.84 110.07 225.74 100.93 258.15 98.20C291.32 95.45 255.14 147.24 230.04 155.89Z',
	// Left wings (less spread)
	wing3Path:
		'M102.92 133.33C122.81 155.59 171.89 152.03 190.76 150.50C192.22 150.33 193.00 148.54 192.16 147.30C168.36 112.11 122.33 86.14 98.42 75.21C73.68 63.99 85.47 115.71 102.92 133.33Z',
	wing4Path:
		'M98.96 157.89C120.19 174.55 168.96 150.98 185.55 142.19C186.87 141.53 187.00 139.59 185.79 138.70C156.16 112.07 102.26 104.93 78.85 102.20C54.68 99.45 78.86 149.24 98.96 157.89Z',
	// Arms - both left and right
	arms: [
		{ d: 'M107.22 139.00L101.60 166.70C101.42 167.59 101.03 168.42 100.47 169.12L91.85 179.87', side: 'left' },
		{ d: 'M201.62 140.17L207.62 167.80C207.81 168.68 208.21 169.50 208.78 170.20L218.00 180.87', side: 'right' },
	],
	// Stinger - bottom right curl (new position)
	stinger:
		'M192.26 231.41C188.79 221.45 177.44 228.41 182.27 236.06C186.42 242.62 194.71 248.33 201.09 248.75C202.33 248.83 202.70 247.39 201.75 246.59C196.21 241.92 195.43 240.28 192.26 231.41Z',
	// Communicator Badge (Star Trek style)
	badge: {
		outerEllipse: { cx: 170, cy: 143.76, rx: 14.1, ry: 10.86 },
		innerEllipse: { cx: 170, cy: 143.76, rx: 12.19, ry: 9.34 },
		starPath:
			'M170 130.58C170.75 130.58 171.40 131.09 171.60 131.82L173.55 139.24L179.09 142.47C179.60 142.77 179.91 143.32 179.91 143.91C179.91 144.51 179.60 145.06 179.09 145.36L173.55 148.59L171.60 156.01C171.40 156.74 170.75 157.25 170 157.25C169.25 157.25 168.60 156.74 168.40 156.01L166.45 148.59L160.91 145.36C160.40 145.06 160.09 144.51 160.09 143.91C160.09 143.32 160.40 142.77 160.91 142.47L166.45 139.24L168.40 131.82C168.60 131.09 169.25 130.58 170 130.58Z',
		starHighlightPath:
			'M171.60 131.82C171.40 131.09 170.75 130.58 170 130.58C169.25 130.58 168.60 131.09 168.40 131.82L166.45 139.24L160.91 142.47L168.98 144.88C169.65 145.08 170.35 145.08 171.02 144.88L179.09 142.47L173.55 139.24L171.60 131.82Z',
	},
};
